<div class="loader-container">
    <div class="loader-background"></div>
    <div class="loader" [ngClass]="{'!p-2': !expanded}">

        <div [ngClass]="{'closed' : !expanded}">
            <img src="assets/gifs/pill.gif" class="pill-gif">
            <span *ngIf="(loadedPercent$ | async) as loadedPercent" class="progress">Confirmed {{loadedPercent}}%</span>
            <div (click)="onExpandCollapse()" *ngIf="!expanded" class="hidden-area-to-expand"></div>
        </div>
        <div class="header-container flex flex-row" *ngIf="expanded" (click)="onExpandCollapse()">
            <div>
                <div class="header">{{header}}
                    <img src="assets/icons/icon-chevron-down-gray.svg ">
                </div>
                <div class="sub-header">
                    We’re confirming your transactions; this may take a while. Feel free to use the rest of the app.
                </div>
            </div>
        </div>
    </div>
</div>
